import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import { th } from "date-fns/locale";
import {
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { useState } from "react";
import { TextInput } from "../Input/Input";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Box from "@mui/material/Box";
import { memo } from "react";
import { ButtonClose, ButtonOther } from "../Button/Button";
import moment from "moment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { InputAdornment, IconButton } from "@mui/material";

const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  },
};

export function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
  {
    label: <label>วันนี้</label>,
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: <label>เมื่อวาน</label>,
    range: () => ({
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday,
    }),
  },

  {
    label: <label>สัปดาห์นี้</label>,
    range: () => ({
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek,
    }),
  },
  {
    label: <label>สัปดาห์ก่อน</label>,
    range: () => ({
      startDate: defineds.startOfLastWeek,
      endDate: defineds.endOfLastWeek,
    }),
  },
  {
    label: <label>เดือนนี้</label>,
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth,
    }),
  },
  {
    label: <label>เดือนก่อน</label>,
    range: () => ({
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth,
    }),
  },
]);

function DateRange({ onClick, onCancel, open, onChange, ranges }) {
  const [opens, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const DialogDate = () => {
    return (
      <>
        <Dialog
          open={opens}
          maxWidth="1500"
          PaperProps={{ style: { borderRadius: 10 } }}
        >
          <Box component="container" noValidate sx={{ mt: 1 }}>
            <DialogContent dividers="paper">
              <DateRangePicker
                onChange={(item) => {
                  setDate([item.selection]);
                }}
                locale={th}
                showSelectionPreview={false}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={date}
                staticRanges={defaultStaticRanges}
                showMonthAndYearPickers={true}
                direction="horizontal"
              />
            </DialogContent>
            <DialogActions>
              <ButtonOther
                onClick={() => {
                  setStartDate(date[0].startDate);
                  setEndDate(date[0].endDate);
                  onClick(date);
                  setOpen(false);
                }}
                message="ตกลง"
              />
              <ButtonClose onClick={() => setOpen(false)} />
            </DialogActions>
          </Box>
        </Dialog>
      </>
    );
  };
  return (
    <>
      <div className="date-range-picker">
        <TextInput
          width="110%"
          onClick={() => setOpen(!opens)}
          value={
            moment(startDate).format("DD/MM/YYYY") +
            " ถึง " +
            moment(endDate).format("DD/MM/YYYY")
          }
          startAdornment={
            <InputAdornment position="start">
              <IconButton
                onClick={() => {
                  setOpen(!opens);
                }}
                edge="start"
              >
                <CalendarMonthIcon />
              </IconButton>
            </InputAdornment>
          }
        />
        {DialogDate()}
      </div>
    </>
  );
}

export default memo(DateRange);
